/* eslint-disable jsx-a11y/alt-text */
import { Typography, CardContent } from "@mui/material";

const HostBenefitsCard = ({ hostBenefitsData }: any) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        padding: "80px 0px 100px 0px",
        flexWrap: "wrap",
        width: "100%",
      }}
    >
      {hostBenefitsData.map((event: any, index: any) => (
        <CardContent
          key={index}
          style={{
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            padding: "10px 10px",
            display: "block",
            textAlign: "center",
            maxWidth: "400px",
            marginRight: "16px",
            borderRadius: "10px",
            height: "280px",
            width: "350px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                backgroundColor: "#F0F0F0",
                borderRadius: 140,
                height: 140,
                width: 140,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                style={{
                  height: "50px",
                  width: "50px",
                }}
                src={event.image}
                color="red"
              />
            </div>
          </div>
          <Typography style={{ marginBottom: "10px" }} variant="h5">
            {event.category}
          </Typography>
          <Typography>{event.dsc}</Typography>
        </CardContent>
      ))}
    </div>
  );
};

export default HostBenefitsCard;
